const trim = (str) => {
  return str.replace(/(^\s*)|(\s*$)/g, '');
};
const isNumber = (str) => {
  return  /^\d+$/.test(str);
}; 
const strLength = (str) => {
  let length = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    length += charCode > 0 && charCode <= 128 ? 1 : 2;
  }
  return length;
}
export { trim,isNumber,strLength };
